import React from 'react';
import BaseTableBody from '@material-ui/core/TableBody';

const TableBody = (props) => <BaseTableBody {...props} />;

export default TableBody;
